<template>
  <Block
    type="cta"
    icon="block-cta"
    :id="id"
    :collections="collections"
    :show-controls="showControls"
    :searchable="searchable"
  >
    <h2 class="ag-block__title mt-1">
      <a :href="url" target="_blank">{{ text }}</a>
    </h2>
    <p class="ag-block__url text-supplement">{{ url }}</p>
  </Block>
</template>

<script>
import Block from "./Block.vue"

export default {
  components: {
    Block
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    searchable: {
      type: Boolean,
      required: true
    },
    collections: {
      type: Array,
      default: () => []
    },
    showControls: {
      type: Boolean,
      default: false
    }
  }
}
</script>
